// These must be the first lines in src/index.js
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

//next
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import './App.less'
import App from './App'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationFr from './translations/fr/'
import translationEn from './translations/en/'
import { defineCustomElements } from '@iwm-ds/react'

// Suppress benign library errors (ResizeObserver, DOM manipulation during unmount)
// These errors occur from Ant Design and CSS-in-JS style injection during navigation/unmounting
const originalConsoleError = window.console.error
window.console.error = (...args: any[]) => {
  const msg = args[0]?.toString() || ''
  // Suppress ResizeObserver loop errors (benign Ant Design timing issue)
  if (msg.includes('ResizeObserver')) {
    return
  }
  // Suppress insertBefore errors during style injection (benign CSS module race condition)
  if (msg.includes('insertBefore') && msg.includes('Node')) {
    return
  }
  originalConsoleError(...args)
}

// Catch runtime errors before they bubble to error boundary
const suppressBenignErrors = (event: ErrorEvent) => {
  const msg = event.message || event.error?.message || ''
  const errorName = event.error?.name || ''
  
  // Suppress ResizeObserver errors
  if (msg.includes('ResizeObserver')) {
    event.stopImmediatePropagation()
    event.preventDefault()
    return true
  }
  
  // Suppress NotFoundError from insertBefore during style injection
  if (errorName === 'NotFoundError' && msg.includes('insertBefore')) {
    event.stopImmediatePropagation()
    event.preventDefault()
    return true
  }
  
  return false
}

window.addEventListener('error', suppressBenignErrors)
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || event.reason?.toString() || ''
  if (msg.includes('ResizeObserver') || (msg.includes('insertBefore') && msg.includes('Node'))) {
    event.stopImmediatePropagation()
    event.preventDefault()
  }
})

defineCustomElements()

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: translationEn,
      fr: translationFr,
    },
    lng: navigator.language.includes('fr') ? 'fr' : 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)
